import {cs}             from "@Common/react/chain-services";
import {isDevQuan}      from "@Common/ui-components/debug/is-dev-quan";
import {isXdQaNoPopup}  from "@Common/ui-components/debug/is-xd-qa-no-popup";

import {BrowserWarningModal} from "./browser-warning-modal/browser-warning-modal";
import {Popups}              from "./popups/popups";

export const SystemMessages = ({next}) => cs(
    ["browserWarningModal", (_, next) => BrowserWarningModal({next})],
    ({browserWarningModal}, next) => (isDevQuan() || isXdQaNoPopup()) ? next() : Popups({
        disabled: browserWarningModal.showing,
        next,
    }),
    () => next(),
);
